/**
 * Simple implementation of lodash-esque `pick` for grabbing certain properties from an object.
 * @param {Array} properties - An array of string values that map to properties on an object to extract.
 * @param {Object} object - The parent object, containing one or more properties that we want to extract into a new object.
 * @return {Object} A new object, comprised of only the properties passed in the `properties` option.
 */

import dotProp from 'dot-prop'

export default (properties = [], object) =>
    properties
        .filter((key) => Object.prototype.hasOwnProperty.call(object, key))
        .reduce((filtered, key) => {
            dotProp.set(filtered, key, dotProp.get(object, key))
            return filtered
        }, {})
